
import {defineComponent} from 'vue';
import Button from "primevue/button";
import Card from "primevue/card";
import Panel from "primevue/panel";
import InfoButton from "@/components/legend/InfoButton.vue";

export default defineComponent({
  name: "FormLegend",
  components: {Panel, Card, Button, InfoButton},
  props: {
    toggleable: {type: Boolean, required: true},
    collapsed: {type: Boolean, required: true},
    legendInfo: {type: Boolean, required: false, default: false},
    legendSubtitle: {type: Boolean, required: false, default: false},
    legendItems: {type: Array, required: true},
  },
})
